import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const DirLayout = ({ children }) => {
  const {
    Language: { selectedLanguage },
    Mode,
  } = useSelector((state) => state)

  useEffect(() => {
    return Mode.selectedMode === 'dark'
      ? ((document.body.style.backgroundColor = '#111111'),
        (document.body.style.color = 'var(--iron)'))
      : ((document.body.style.backgroundColor = '#f9fafc'),
        (document.body.style.color = 'var(--black)'))
  }, [Mode.selectedMode])

  return (
    <div id="dirLayout" dir={selectedLanguage === 'AR' ? 'rtl' : 'ltr'}>
      {children}
    </div>
  )
}

export default DirLayout
